import Profile from "../components/events/favEvents/eventListing"
import Nav from "../components/Nav/nav";

const ProfPage = () => {
  return (
    <div>
      <Nav />
      <Profile />
    </div>
  );
};

export default ProfPage;